<script setup lang="ts">
const site = useSite();
</script>

<template>
  <NuxtLink
    v-if="site?.announcementLive === 'true' && site?.announcementText"
    :to="site?.announcementLink"
    class="announcement btn from-left"
  >
    {{ site?.announcementText }}
  </NuxtLink>
  <NuxtLink
    v-if="site?.announcementLive === 'true' && site?.announcementText2"
    :to="site?.announcementLink2"
    class="announcement2 btn from-left"
  >
    {{ site?.announcementText2 }}
  </NuxtLink>
</template>
